import { render, staticRenderFns } from "./UserChangePassword.vue?vue&type=template&id=4a71afd0&scoped=true&"
import script from "./UserChangePassword.vue?vue&type=script&lang=js&"
export * from "./UserChangePassword.vue?vue&type=script&lang=js&"
import style0 from "./UserChangePassword.vue?vue&type=style&index=0&id=4a71afd0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a71afd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a71afd0')) {
      api.createRecord('4a71afd0', component.options)
    } else {
      api.reload('4a71afd0', component.options)
    }
    module.hot.accept("./UserChangePassword.vue?vue&type=template&id=4a71afd0&scoped=true&", function () {
      api.rerender('4a71afd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/UserChangePassword.vue"
export default component.exports